const inputsMessages = {
	fileSizeErr: (fileName) => `<strong>${fileName}</strong><br>Maximum size is 20Mb`,
	fileFormatErr: (fileName) => `<strong>${fileName}</strong><br>Invalid format. Use Doc, PDF, TXT, RTF`,
	fileSuccess: (fileName) => `<strong>${fileName}</strong><br>uploaded successfully`,
	checkEmail: 'Please check your email',
	checkLink: 'Please check your link',
	confirmFild: 'Please confirm the field',
	maxLengthxceed: (maxLength) => `This field must not exceed ${maxLength} characters`,
	agreementNotChecked: 'Please agree to the Privacy Policy'
}

function setValidInputState(input) {
	input.classList.remove('invalid')
	input.classList.add('success')
}

function setInvalidInputState(input) {
	input.classList.add('invalid')
	input.classList.remove('success')
}

function setDefaultInputState(input) {
	input.classList.remove('invalid')
	input.classList.remove('success')
}

export function clearInputData(input) {
	if (input.type === 'text' || input.type === 'email' || input.type === 'url') {
		input.value = ''
		setDefaultInputState(input)
	} else if (input.type === 'file') {
		removeFile()
	} else if (input.type === 'checkbox') {
		input.checked = false
	}
}

const inputs = [...document.querySelectorAll('form input, form textarea')]
inputs.forEach((input) => {
	if (input.type === 'text' || input.type === 'email' || input.type === 'url' || input.tagName === 'TEXTAREA') {
		input.addEventListener('input', (e) => checkIsValidInput(e.target))

		if (input.required) {
			input.addEventListener('blur', (e) => checkIsValidInput(e.target))
		} else {
			input.addEventListener('blur', (e) => {
				e.target.value.length === 0 && setDefaultInputState(e.target)
			})
		}
	}
})

function checkIsValidInput(input) {
	if (input.type === 'url') {
		input.value = addUrlProtocol(input.value)
	}

	validateInputLength(input, input.maxLength - 1)
	if (input.type === 'email') validateEmailAddres(input)
	if (input.type === 'url') validateUrlAddres(input)
}

function validateInputLength(input, maxLength) {
	const errorBlock = input.nextElementSibling
	if (input.value.length > maxLength) {
		setInvalidInputState(input)
		errorBlock.textContent = inputsMessages.maxLengthxceed(maxLength)
	} else if (input.value.length > 0) {
		setValidInputState(input)
	} else {
		setInvalidInputState(input)
		errorBlock.textContent = inputsMessages.confirmFild
	}
}

function validateEmailAddres(input) {
	const EMAIL_REGEXP =
		/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu
	const errorBlock = input.nextElementSibling

	if (!EMAIL_REGEXP.test(input.value)) {
		setInvalidInputState(input)
		errorBlock.textContent = inputsMessages.checkEmail
	}
}

function addUrlProtocol(url) {
	if ('http://'.startsWith(url.slice(0, 7)) || 'https://'.startsWith(url.slice(0, 8))) {
		return url
	} else {
		return `https://${url}`.slice(0, 2000)
	}
}

function validateUrlAddres(input) {
	const URL_REGEXP = /https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
	const errorBlock = input.nextElementSibling

	if (!URL_REGEXP.test(input.value)) {
		setInvalidInputState(input)
		errorBlock.textContent = inputsMessages.checkLink
	}
}

function checkIsAgreementChecked(checkbox) {
	const errorBlock = checkbox.parentNode.querySelector('.form-error')
	if (!checkbox.checked) {
		setInvalidInputState(checkbox)
		if (errorBlock) {
			errorBlock.textContent = inputsMessages.agreementNotChecked
		}
	} else {
		setDefaultInputState(checkbox)
	}
}

const fileInput = document.querySelector('input[type="file"]')
const fileInputLabel = fileInput?.closest('label')
const fileInputPlaceholder = fileInputLabel?.querySelector('.file-input__placeholder')
const fileInputInfo = fileInputLabel?.querySelector('.file-input__info')

const removeIcon = document.querySelector('.file-input__remove')

if (fileInputLabel) {
	fileInputLabel.addEventListener('dragover', function (event) {
		event.preventDefault()
	})

	fileInput.addEventListener('change', (e) => {
		const file = e.target.files[0]
		if (file) validateFile(file)
	})

	fileInputLabel.addEventListener('drop', dropHandler)
	removeIcon.addEventListener('click', removeFile)
}

function dropHandler(evt) {
	evt.preventDefault()

	const file = evt.dataTransfer.files[0]
	if (file) validateFile(file)

	const dT = new DataTransfer()
	dT.items.add(file)
	fileInput.files = dT.files
}

let isValidFile

function validateFile(file) {
	removeIcon.classList.add('shown')

	isValidFile = true

	if (!isValidFileSize(file, 20010)) {
		setInvalidInputState(fileInputLabel)
		fileInputPlaceholder.style.display = 'none'
		fileInputInfo.innerHTML = inputsMessages.fileSizeErr(file.name)
		isValidFile = false
	}

	const availableExtensions = fileInput.accept.split(',')

	if (!isValidFileExtension(file, availableExtensions)) {
		setInvalidInputState(fileInputLabel)
		fileInputPlaceholder.style.display = 'none'
		fileInputInfo.innerHTML = inputsMessages.fileFormatErr(file.name)
		isValidFile = false
	}

	if (!isValidFile) {
		return false
	}

	setValidInputState(fileInputLabel)
	fileInputPlaceholder.style.display = 'none'
	fileInputInfo.innerHTML = inputsMessages.fileSuccess(file.name)
	isValidFile = true
}

function removeFile(e) {
	e?.preventDefault()
	const dT = new DataTransfer()
	fileInput.files = dT.files
	setDefaultInputState(fileInputLabel)
	fileInputPlaceholder.style.display = 'block'
	fileInputInfo.innerHTML = ''
	removeIcon.classList.remove('shown')
	isValidFile = true
}

function isValidFileSize(file, maxSize) {
	const fileSize = file.size / 1000
	return fileSize < maxSize
}

function isValidFileExtension(file, extensions) {
	const fileName = file.name
	const fileExt = fileName.slice(fileName.lastIndexOf('.'))
	return extensions.includes(fileExt.toLowerCase())
}

const submitBtn = document.querySelector('.wpcf7 button[type="submit"]')
const submitForm = document.querySelector('.wpcf7-form')
const dataAgreementCheckbox = document.getElementById('data-agreement')

if (submitBtn) {
	submitBtn.addEventListener('click', (e) => {
		inputs.forEach((input) => {
			if (input.type !== 'file' && input.type !== 'hidden' && input.type !== 'checkbox' && input.required) {
				checkIsValidInput(input)
			}
		})

		checkIsAgreementChecked(dataAgreementCheckbox)

		const isInvalidFields = submitForm.querySelectorAll('.invalid')

		if (isInvalidFields.length) {
			e.preventDefault()
		} else {
			setTimeout(() => (submitBtn.disabled = true), 0)
		}
	})

	const wpcf7Elm = document.querySelector('.wpcf7')

	wpcf7Elm.addEventListener('wpcf7mailsent', () => {
		inputs.forEach((input) => {
			setDefaultInputState(input)
		})

		localStorage.setItem('isShowPopup', 'on')
		location.reload()
	})
}
